module.exports = __webpack_public_path__ + "img/productBgImg8.7f129b71.png";